import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "../components/L";
import Seo from "../components/Seo";
import { LANDINGS, getLandingData } from "../landingPages";
import { useLang } from "../context/LanguageContext";

export default function PopularSearches() {
  const { lang } = useLang();
  const de = lang === "de";
  return (
    <div>
      <Seo pageKey="beliebte-suchen" title={de ? "Beliebte Suchen | MyCleaner.ch" : "Popular searches | MyCleaner.ch"}
        description={de ? "Alle Regionen und Leistungen von MyCleaner.ch auf einen Blick: Putzfrau, Reinigung und Haushaltshilfe in Ihrer Stadt." : "All regions and services of MyCleaner.ch at a glance."} />
      <section className="pt-[116px] pb-10 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-[1100px] mx-auto px-5 md:px-6">
          <h1 className="font-head font-extrabold text-4xl sm:text-5xl text-slate-900 mb-3">{de ? "Beliebte Suchen" : "Popular searches"}</h1>
          <p className="text-slate-600">{de ? "Finden Sie Ihre Putzfrau, Reinigung oder Haushaltshilfe in Ihrer Region." : "Find your cleaner or home help in your region."}</p>
        </div>
      </section>
      <section className="pb-20">
        <div data-testid="popular-searches-list" className="max-w-[1100px] mx-auto px-5 md:px-6 flex flex-wrap gap-2.5">
          {LANDINGS.map((l) => (
            <Link key={l.slug} to={`/${l.slug}`} className="inline-flex items-center gap-1.5 text-[13px] text-slate-600 bg-white border border-slate-200 rounded-full px-3.5 py-1.5 hover:text-teal-700 hover:border-teal-400 transition-colors">
              <MapPin className="w-3.5 h-3.5 text-teal-600" /> {getLandingData(l.slug, lang).keyword.replace(/\?$/, "")}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
